var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIllustrationPlaceholder = function SvgIllustrationPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 86,
    viewBox: "0 0 88 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "IllustrationPlaceholder_svg__a",
    d: "M0 86h88V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 83.5c0 1.38-18.58 2.5-41.5 2.5S2 84.88 2 83.5C2 82.119 20.58 81 43.5 81S85 82.119 85 83.5",
    fill: "#EAF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 0H2a2 2 0 0 0-2 2v10h88V2a2 2 0 0 0-2-2",
    fill: "#A7E3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12v50a2 2 0 0 0 2 2h84a2 2 0 0 0 2-2V12H0",
    fill: "#D3EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 25h49a2 2 0 0 1 2 2v22a2 2 0 0 1-2 2H19a2 2 0 0 1-2-2V27a2 2 0 0 1 2-2",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 46h-6a1.5 1.5 0 0 1 0-3h6a1.5 1.5 0 1 1 0 3",
    fill: "#5FCEF5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "IllustrationPlaceholder_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#IllustrationPlaceholder_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5FCEF5",
    mask: "url(#IllustrationPlaceholder_svg__b)",
    d: "M24 37h40v-1H24zM24 33h40v-1H24zM24 41h26v-1H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.086 5.916a2.182 2.182 0 1 1-4.365 0 2.182 2.182 0 0 1 4.365 0M17.044 5.916a2.182 2.182 0 1 1-4.364 0 2.182 2.182 0 0 1 4.364 0",
    fill: "#FFF",
    mask: "url(#IllustrationPlaceholder_svg__b)"
  }))));
};
export default SvgIllustrationPlaceholder;